import { graphql } from "@/gql";

export const contactCreditBalancesQuery = graphql(`
  query ContactCreditBalances($id: ID!) {
    contact(id: $id) {
      id
      credit_balances {
        currency
        amount
      }
    }
  }
`);
